import React from 'react'

export default function Cart() {
    return (
        <div>
            CART
        </div>
    )
}
